<template>
  <span class="inline-block rounded-full px-2 text-xs" v-on="$listeners"
        :class="config[color].class">
  <slot class="text-xs">{{ showValue ? value : '' }}</slot>
  </span>
</template>

<script>
export default {
  // text-gray-600 bg-gray-100
  name: "badges",
  props: {
    value: {
      type: String,
      default: 'Message'
    },
    showValue: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: 'default'
    }
  },
  data: () => ({
    config: {
      success: {
        class: 'bg-green-500 text-white',
      },
      success_min: {
        class: 'bg-green-100 text-green-600',
      },
      success_max: {
        class: 'bg-green-100 text-green-800 border-green-800 border',
      },
      success_mid: {
        class: 'bg-green-100 text-green-400 border-green-400 border',
      },
      danger_min: {
        class: 'bg-red-100 text-red-600 border-red-600 border',
      },
      danger: {
        class: 'bg-red-500 text-white ',
      },
      danger_max: {
        class: 'bg-red-200 text-red-500 border-red-500 border',
      },
      warning: {
        class: 'bg-amber-500 text-white',
      },
      warning_min: {
        class: 'bg-amber-100 text-amber-500',
      },
      primary: {
        class: 'bg-blue-500 text-white',
      },
      primary_dark: {
        class: 'bg-blue-800 text-white',
      },
      primary_min: {
        class: 'bg-blue-300 text-blue-700 border-blue-700 border',
      },
      info: {
        class: 'bg-blue-400 text-white',
      },
      info_min: {
        class: 'bg-blue-100 text-blue-400 border-blue-400 border',
      },
      default: {
        class: 'bg-gray-200 text-gray-800',
      },
      default_mid: {
        class: 'bg-gray-200 text-gray-800 border-gray-800 border',
      }
    }
  })
}
</script>

<style scoped>

</style>
